import { styled } from '@mui/material';

export const SessionReplayCanvasWrapper = styled('div')<{ width: number | string; height: number | string }>(
    ({ width, height }) => ({
        width: width,
        height: height,
        border: '1px solid #333333',
        borderRadius: 8,
        margin: '0 auto',
    }),
);

export const ReplayCanvasInnerWrapper = styled('div')<{ $displayWidth: number; $aspectRatio: string }>(
    ({ $displayWidth, $aspectRatio }) => ({
        width: $displayWidth,
        maxWidth: '100%',
        aspectRatio: $aspectRatio,
        position: 'relative',
        margin: '0 auto',
    }),
);
